//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MattingSlider",
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    x: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    amount() {
      return this.max - this.min;
    },
    positionX() {
      return (this.x - this.min) / this.amount;
    },
  },
  watch: {
    positionX: {
      async handler(newVal) {
        if (this.x > this.max) {
          newVal = 1;
        }
        await this.$nextTick();
        const controlElem = this.$refs.control;
        const barElem = this.$refs.bar;
        const computedVal = newVal * 100;
        controlElem.style.left = computedVal + "%";
        barElem.style.width = computedVal + "%";
      },
      immediate: true,
    },
  },
  created() {
    window.addEventListener("mousemove", this.onDragging.bind(this));
    window.addEventListener("mouseup", this.onDragged.bind(this));
  },
  mounted() {
    this.getDomRect();
  },
  methods: {
    setPosition(val) {
      const x = this.amount * val + this.min;
      this.$emit("x", x);
    },
    computedVal(evt) {
      const { clientX } = evt;
      const full = this.full;
      const baseX = this.baseX;
      let val = (clientX - baseX) / full;
      val = Math.min(val, 1);
      val = Math.max(val, 0);
      return val;
    },
    onDragStart() {
      this.$emit("on-drag-start");
      this.dragging = true;
      this.status = "drag";
      this.getDomRect();
    },
    onDragging(evt) {
      if (!this.dragging) return;
      this.$emit("on-dragging");
      let val = this.computedVal(evt);
      this.setPosition(val);
    },
    onDragged() {
      if (!this.dragging) return;
      this.$emit("on-dragged");
      this.dragging = false;
    },
    onClick(evt) {
      if (this.status === "drag") {
        this.status = null;
        return;
      }
      this.$emit("on-click");
      let val = this.computedVal(evt);
      this.setPosition(val);
      this.$emit("on-dragged");
    },
    getDomRect() {
      const { left, width } = this.$refs.slider.getBoundingClientRect();
      this.baseX = left;
      this.full = width;
    },
  },
};
